import {
    MUTATION_DEPOSIT_EDIT,
 } from "./types";

export default {
    [MUTATION_DEPOSIT_EDIT]: async (state, data) => {
        state.openEditDeposit = data;
    }
}